import { DARK_BLUE } from "shared/consts";
import styled from "styled-components";

export const HallContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 15px;
  margin-bottom: 28px;
`;

export const HallTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 1.2;
  color: ${DARK_BLUE};
`;

export const HallBody = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(48px, auto));
  gap: 12px 11px;
`;